import React from "react";
import { FormField } from "./FormField";
import "./ContentField.scss";

interface ContentFieldProps {
  contentKo: string;
  contentEn: string;
  onContentKoChange: (value: string) => void;
  onContentEnChange: (value: string) => void;
  required?: boolean;
  error?: string;
}

export const ContentField: React.FC<ContentFieldProps> = ({
  contentKo,
  contentEn,
  onContentKoChange,
  onContentEnChange,
  required = false,
  error,
}) => {
  return (
    <div className="content-field">
      <FormField label="본문 - 한국어" required={required} error={error}>
        <textarea
          className="content-textarea"
          value={contentKo}
          onChange={(e) => onContentKoChange(e.target.value)}
          placeholder="한국어 본문을 입력하세요"
          rows={8}
        />
      </FormField>

      <FormField label="본문 - 영어" required={required}>
        <textarea
          className="content-textarea"
          value={contentEn}
          onChange={(e) => onContentEnChange(e.target.value)}
          placeholder="영어 본문을 입력하세요"
          rows={8}
        />
      </FormField>
    </div>
  );
};
